export const defaultState = {
    isFetching: false,
    newsrooms: undefined,
    core: undefined,
};
